import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { TbLogout2 } from "react-icons/tb";
import usePrimaryColor from "../../hooks/usePrimaryColor";
import ConfirmAndCancelButtons from "../buttons/ConfirmAndCancelButtons";
//This component is only used for the logout button, leave it at that
//It's old and uncostamizable, all other confirmation dialogs are form based
export default function AlertPopUp({
  btnMessage,
  onAgree,
  title,
  content,
  btnNegativeTitle,
  btnPoisitveTitle,
  isEnabled,
  ...rest
}) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgree = () => {
    onAgree();
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        variant="text"
        sx={{
          display: "flex",
          justifyContent: "start",
          gap: 2,
          pl: 2,
        }}
        size="large"
        onClick={handleClickOpen}
        {...rest}
        disabled={!isEnabled && isEnabled !== undefined}
        data-testid="header.user-menu.logout-button"
      >
        {t(btnMessage)}{" "}
      </Button>
      <Dialog
        open={open}
        fullWidth
        onClose={handleClose}
        maxWidth={"xs"}
        PaperProps={{ sx: { borderRadius: "18px" } }}
      >
        <Stack p={2} justifyContent={"center"} alignItems={"center"}>
          <TbLogout2 size={100} color={usePrimaryColor()} />
        </Stack>
        <DialogContent sx={{ textAlign: "center" }}>
          {t("ReallyWantLogOut")}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <ConfirmAndCancelButtons
            confirmTitle="LogOut"
            cancelTitle="Stay"
            onConfirm={handleAgree}
            onCancel={handleClose}
            confirmButtonProps="submit"
            testId="header.user-menu.logout-dialog"
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
